module.exports = __webpack_public_path__ + "static/media/logo_lvn_black.715fb339.svg";